(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-block-title"] && !Shopify.designMode) return;
  try {
    function fixSwymIcons() {
    document.querySelectorAll('#swym-atw-pdp-button-icon').forEach((svg) => {
      if (!svg.hasAttribute('viewBox')) {
        svg.setAttribute('viewBox', '0 0 24 24');
        svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
      }
    });
  }

  document.addEventListener('DOMContentLoaded', fixSwymIcons);
  setTimeout(fixSwymIcons, 1000);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-variant-options"] && !Shopify.designMode) return;
  try {
    (() => {
    const APPLIED_ATTR = 'data-ts-on-order-render-applied';

    function getOnOrderValue(select, optionValue) {
      if (!select || !optionValue) return 'false';

      const originalOption = Array.from(select.options).find((option) => option.value === optionValue);
      if (!originalOption) return 'false';

      return originalOption.getAttribute('data-on-order') || 'false';
    }

    function getBadgeLabel(select) {
      const option = Array.from(select.options).find(
        (o) => o.dataset.onOrderLabel
      );
      return option ? option.dataset.onOrderLabel : '';
    }

    function updateSelectedItemBadge(select) {
      if (!select || !select.tomselect) return;

      const tom = select.tomselect;
      const selectedValue = select.value;
      const selectedItem = tom.control.querySelector('.item');

      if (!selectedItem || !selectedValue) return;

      const originalOption = Array.from(select.options).find((option) => option.value === selectedValue);
      const onOrder = originalOption && originalOption.getAttribute('data-on-order') === 'true';
      const badgeLabel = getBadgeLabel(select);

      const currentText = selectedItem.textContent.trim();

      selectedItem.innerHTML = `
        <span class="item__value">${currentText.replace(badgeLabel, '').trim()}</span>
          ${onOrder ? `<span class="variant-option-badge">${badgeLabel}</span>` : ''}
        `;
    }

    function applyCustomTomSelectRender(select) {
      if (!select || select.getAttribute(APPLIED_ATTR) === 'true') return;
      if (!select.classList.contains('custom-select')) return;
      if (!select.tomselect) return;

      const tom = select.tomselect;
      select.setAttribute(APPLIED_ATTR, 'true');

      tom.settings.render = tom.settings.render || {};

      tom.settings.render.option = function(data, escape) {
        const onOrder = getOnOrderValue(select, data.value) === 'true';

        return `
          <div class="option option--custom">
            <span class="option__value">${escape(data.text)}</span>
            ${onOrder ? `<span class="variant-option-badge">${getBadgeLabel(select)}</span>` : ''}
          </div>
        `;
      };

      tom.clearCache();
      tom.refreshOptions(false);

      updateSelectedItemBadge(select);

      select.addEventListener('change', function () {
        updateSelectedItemBadge(select);
      });

      tom.on('item_add', function () {
        updateSelectedItemBadge(select);
      });

      tom.on('initialize', function () {
        updateSelectedItemBadge(select);
      });
    }

    function initExistingSelects(root = document) {
      root.querySelectorAll('select.custom-select').forEach(applyCustomTomSelectRender);
    }

    function observeTomSelectInit() {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (!(node instanceof HTMLElement)) return;

            if (node.matches('.ts-wrapper')) {
              const select = node.previousElementSibling;
              if (select && select.matches('select.custom-select')) {
                applyCustomTomSelectRender(select);
              }
            }

            if (node.querySelectorAll) {
              node.querySelectorAll('.ts-wrapper').forEach((wrapper) => {
                const select = wrapper.previousElementSibling;
                if (select && select.matches('select.custom-select')) {
                  applyCustomTomSelectRender(select);
                }
              });

              node.querySelectorAll('select.custom-select.tomselected').forEach(applyCustomTomSelectRender);
            }
          });
        });
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        initExistingSelects();
        observeTomSelectInit();
      });
    } else {
      initExistingSelects();
      observeTomSelectInit();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initExistingSelects(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
